import { isNull } from 'lodash';

import type { PersonForm } from '@appTypes/common/types';

import { dtoDateFormat } from '../constants';

export type FormattedOAProfile = {
  oaMember?: boolean;
  oaMemberNumber?: string;
  oaElectionDate?: string | null;
  oaOrdealDate?: string | null;
  oaBrotherhoodDate?: string | null;
  oaVigilDate?: string | null;
  oaActive?: boolean;
};

export default function formatOAProfile(
  profile: Partial<PersonForm>,
): FormattedOAProfile {
  const {
    oaActive,
    oaMember,
    oaMemberNumber,
    oaElectionDate,
    oaOrdealDate,
    oaBrotherhoodDate,
    oaVigilDate,
  } = profile;

  return {
    oaActive: oaActive === undefined ? undefined : !!oaActive.length,
    oaMember: oaMember === undefined ? undefined : !!oaMember.length,
    oaMemberNumber: oaMemberNumber,
    oaElectionDate: isNull(oaElectionDate)
      ? null
      : oaElectionDate
      ? oaElectionDate.format(dtoDateFormat)
      : undefined,
    oaOrdealDate: isNull(oaOrdealDate)
      ? null
      : oaOrdealDate
      ? oaOrdealDate.format(dtoDateFormat)
      : undefined,
    oaBrotherhoodDate: isNull(oaBrotherhoodDate)
      ? null
      : oaBrotherhoodDate
      ? oaBrotherhoodDate.format(dtoDateFormat)
      : undefined,
    oaVigilDate: isNull(oaVigilDate)
      ? null
      : oaVigilDate
      ? oaVigilDate.format(dtoDateFormat)
      : undefined,
  };
}
